import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import {
    AccessPointFilter,
    RadioBandFilter,
    SiteFilter,
    StatusFilter,
    TimeRangeFilter,
    WirelessControllerFilter,
} from '../../filters';
import RadioListPanel from '../../panels/ipm-list-panels/RadioListPanel';

export const pageId = 'radios';

export default function RadiosPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Radios`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <WirelessControllerFilter />
                    <AccessPointFilter />
                    <RadioBandFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <RadioListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
